module.exports = __webpack_public_path__ + "static/img/wepay.0980c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay/wepay.png
// module id = rBcs
// module chunks = 1